module.exports = __webpack_public_path__ + "img/43244631003931.941dc8a9.png";